<section class="list-wrapper-style-2 section-pd academic_writing_section bg-light-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>2か国語に対応</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="academic_slider_section">
            <div id="subject-verb-d" class="carousel slide" data-ride="carousel">
                <div class="bullet_points_sections p-0">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-lg-9 col-md-10">
                            <div class="list-wrapper-content-2 p-0">
                                <p class="text-center">Trinkaは、英語とスペイン語の２か国語に対応する文法チェッカーです。</p>
                                <ul class="carousel-indicators justify-content-center">
                                    <li data-target="#subject-verb-d" data-slide-to="0" class="active">英語</li>
                                    <li data-target="#subject-verb-d" data-slide-to="1">スペイン語</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-center">
                        <div class="col-lg-6 col-md-6">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h3>英語</h3>
                                    <p>One of the reasons is <span>because</span> <span class="themeColor">that</span> the fabrication cost <span>for</span> <span class="themeColor">of</span> steel members depends upon the material.</p>
                                </div>
            
                                <div class="carousel-item">
                                    <h3>スペイン語</h3>
                                    <p>Una de las razones es <span>porque</span> <span class="themeColor">que</span> el costo de fabricación <span>para</span> <span class="themeColor">de</span> los miembros de acero depende del material.</p>
                                </div>
                                <a class="carousel-control-prev" href="#subject-verb-d" data-slide="prev" aria-label="Previous Slide">
                                    <span>
                                        <svg enable-background="new 0 0 240.823 240.823" version="1.1" viewBox="0 0 240.82 240.82" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">    
                                            <path d="m57.633 129.01 108.3 108.26c4.752 4.74 12.451 4.74 17.215 0 4.752-4.74 4.752-12.439 0-17.179l-99.707-99.671 99.695-99.671c4.752-4.74 4.752-12.439 0-17.191-4.752-4.74-12.463-4.74-17.215 0l-108.3 108.26c-4.679 4.691-4.679 12.511 0.012 17.191z"/>
                                        </svg>
                                    </span>
                                </a>
                                <a class="carousel-control-next" href="#subject-verb-d" data-slide="next" aria-label="Next Slide">
                                    <span>
                                        <svg enable-background="new 0 0 240.823 240.823" version="1.1" viewBox="0 0 240.82 240.82" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m57.633 129.01 108.3 108.26c4.752 4.74 12.451 4.74 17.215 0 4.752-4.74 4.752-12.439 0-17.179l-99.707-99.671 99.695-99.671c4.752-4.74 4.752-12.439 0-17.191-4.752-4.74-12.463-4.74-17.215 0l-108.3 108.26c-4.679 4.691-4.679 12.511 0.012 17.191z"/>
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>